module.exports = __webpack_public_path__ + "img/zlogo.853b6647.png";